import { render, staticRenderFns } from "./ComponentForm.vue?vue&type=template&id=d959e1e4&"
import script from "./ComponentForm.vue?vue&type=script&lang=js&"
export * from "./ComponentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports